// libraries
import React from 'react';
import styled from 'styled-components/native';
import { Control, FieldValues, Path, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// components
import { CustomIcon, CustomText, ErrorText, SpacerRow } from '@components/atoms';

// styles
import { genericStyles } from '@styles/genericStyles';
import { SORTING_DATA_TYPE, SORTING_TYPE } from '@components/organisms';

//types
export interface CheckboxProps<T extends FieldValues> {
  text: string | React.ReactNode;
  control: Control<T>;
  name: Path<T>;
  rules?: { required: boolean };
  defaultValue: SORTING_TYPE;
}

export const FilterCheckbox = <T extends FieldValues>({
  text,
  name,
  control,
  rules,
  defaultValue,
}: CheckboxProps<T>): React.ReactElement => {
  // variables
  const { t } = useTranslation();
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  // renders
  return (
    <Container>
      <ButtonContainer onPress={() => field.onChange(defaultValue)}>
        {typeof text === 'function' ? (
          text
        ) : (
          <CustomText size={14} color={fieldState.error?.type ? 'error' : 'text'}>
            {text}
          </CustomText>
        )}
        <SpacerRow size={0.4} />
        <CustomIcon
          name={field.value === defaultValue ? 'check-square' : 'square'}
          color={fieldState.error?.type ? 'error' : 'text'}
        />
      </ButtonContainer>
      <ErrorText>{(fieldState.error?.type && t('form.errors.required')) || ''}</ErrorText>
    </Container>
  );
};

const Container = styled.View(({ theme: { layout } }) => ({}));

const ButtonContainer = styled.Pressable(({ theme: { layout } }) => ({
  ...genericStyles.rowWithCenterAndSB,
  paddingVertical: layout.padding * 0.2,
}));
